/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  RevokeAPIKeyForUserOptions,
  RevokeAPIKeyForUserStatus200,
  RevokeAPIKeyForUserStatus404,
  RevokeAPIKeyForUserStatus500,
} from '../types/RevokeAPIKeyForUser'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { revokeAPIKeyForUser } from '../clients/revokeAPIKeyForUser'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const revokeAPIKeyForUserMutationKey = () =>
  [{ url: '/v1/user/apikey/:key_id/revoke' }] as const

export function revokeAPIKeyForUserMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = revokeAPIKeyForUserMutationKey()
  return mutationOptions<
    RevokeAPIKeyForUserStatus200,
    ResponseErrorConfig<RevokeAPIKeyForUserStatus404 | RevokeAPIKeyForUserStatus500>,
    RevokeAPIKeyForUserOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ path }) => {
      return revokeAPIKeyForUser({ ...config, path, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @summary Revoke apikey for a user
 * {@link /v1/user/apikey/:key_id/revoke}
 */
export function useRevokeAPIKeyForUser<TContext>(
  options: {
    mutation?: UseMutationOptions<
      RevokeAPIKeyForUserStatus200,
      ResponseErrorConfig<RevokeAPIKeyForUserStatus404 | RevokeAPIKeyForUserStatus500>,
      RevokeAPIKeyForUserOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? revokeAPIKeyForUserMutationKey()

  const baseOptions = revokeAPIKeyForUserMutationOptions(config) as UseMutationOptions<
    RevokeAPIKeyForUserStatus200,
    ResponseErrorConfig<RevokeAPIKeyForUserStatus404 | RevokeAPIKeyForUserStatus500>,
    RevokeAPIKeyForUserOptions,
    TContext
  >

  return useMutation<
    RevokeAPIKeyForUserStatus200,
    ResponseErrorConfig<RevokeAPIKeyForUserStatus404 | RevokeAPIKeyForUserStatus500>,
    RevokeAPIKeyForUserOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    RevokeAPIKeyForUserStatus200,
    ResponseErrorConfig<RevokeAPIKeyForUserStatus404 | RevokeAPIKeyForUserStatus500>,
    RevokeAPIKeyForUserOptions,
    TContext
  >
}
